var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseLive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_OpenChat_keyboard-Copy-2",
    transform: "translate(-275.000000, -36.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.729587,37.5757243 L280.305634,39.9999455 L282.729587,42.4240518 C283.090138,42.784743 283.090138,43.3690144 282.729587,43.7297056 C282.549438,43.9098559 282.31325,44 282.077177,44 C281.840714,44 281.604504,43.9099937 281.424493,43.7297056 L279.000011,41.3053236 L276.575714,43.7296826 C276.395588,43.909833 276.159377,43.999977 275.923098,43.999977 C275.686888,43.999977 275.450838,43.9099708 275.270551,43.7296826 C274.91,43.3691522 274.91,42.7848578 275.270551,42.4240289 L277.694435,39.9999225 L275.270413,37.5757243 C274.909862,37.2151709 274.909862,36.6307617 275.270413,36.2702083 C275.630895,35.9099306 276.214956,35.9099306 276.575576,36.2702083 L278.999989,38.6944295 L281.424217,36.2702083 C281.784906,35.9099306 282.369036,35.9099306 282.729449,36.2702083 C283.090138,36.6307617 283.090138,37.2151709 282.729587,37.5757243 Z",
    id: "icCloseLive"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseLive);
export default __webpack_public_path__ + "static/media/icCloseLive.e9d483a84ffa67ca25ee2b66c28a8406.svg";
export { ForwardRef as ReactComponent };